<template>

    <div :id="chart.idName" style="box-sizing: border-box;
  margin:10px 0;
  width:calc((100% - 100px)/4);
  height:300px;background-color:#FFFFFF;box-sizing:border-box;padding:20px 0 0; border-radius: 10px;"></div>

</template>

<script>
export default {

  props:["chart"],
  data(){
    return{
      val1:'',
      val2:'',
      val3:'',

    }
  },
  methods: {
    myEcharts(n) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById(this.chart.idName));

      // 指定图表的配置项和数据
      var option = {
        title: {
          text: n.title,
          textStyle:{fontSize:12},
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: 20,
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '45%',
            center:['50%','45%'],
            data: [
                    { value: this.val1, name: '微信', itemStyle: { color: 'skyblue' } },
                    { value: this.val2, name: '支付宝', itemStyle: { color: 'yellow' } },
                    { value: this.val3, name: '汇款', itemStyle: { color: 'hotpink' } }
                  ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
     myChart.setOption(option);
    }
  },

  mounted() {
      // httpKit.post($api_eap.user.get).then(res => {
      //     if (res.data.code === '200') {
      //         this.val1=Number(res.data.data.paymentMethod.alipay)
      //         this.val2=Number(res.data.data.paymentMethod.remittance)
      //         this.val3=Number(res.data.data.paymentMethod.weixin)
      //
      //         this.myEcharts(this.chart);
      //     }
      // })
  },

};
</script>

<style lang="less" scoped>
.Echarts{

}
</style>
